var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.classes({ theme: _vm.theme }),attrs:{"data-uh":"property-tile-chip"}},[_vm._t("icon"),_vm._v(" "),_c('span',[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }